export enum CivilStatus {
  SINGLE = 'single',
  MARRIED = 'married',
  WIDOW = 'widow',
  PARTNERSHIP = 'partnership',
  AFTER_MARRIGE = 'afterMarriage',
  SEPARATION = 'separation',
}

export enum FFCivilStatus {
  SINGLE = 'single',
  MARRIED_WITH_SEPARATION_CAPITAL = 'marriedWithSeparationCapital',
  MARRIED_WITHOUT_SEPARATION_CAPITAL = 'marriedWithoutSeparationCapital',
  WIDOW = 'widow',
  PARTNERSHIP = 'partnership',
  AFTER_MARRIGE = 'afterMarriage',
  SEPARATION = 'separation',
}

export enum Profession {
  CIVIL_SERVANT = 21,
  BROKER = 17,
  FINANCIAL_ADVISOR = 14,
  FINANCIAL_BROKER = 18,
  INSURANCE_SPECIALIST = 30,
  ANOTHER_FINANCIAL_SECTOR_EMPLOYEE = 25,
  LAWYER = 6,
  ARCHITECT = 11,
  AUDITOR = 10,
  APOTHECARY = 4,
  CIVIL_ENGINEER = 12,
  BAILIFF = 15,
  ACCOUNTANT = 13,
  DOCTOR = 2,
  NOTARY = 7,
  NURSE = 3,
  SCIENTIST = 19,
  PROSECUTOR = 9,
  LEGAL_COUNSEL = 24,
  PATENT_ATTORNEY = 28,
  REAL_ESTATE_APPRAISER = 27,
  JUDGE = 8,
  TRANSLATOR = 16,
  VET = 5,
  MANAGER = 20,
  UNIFORM_SERVICES = 26,
  SAILOR = 22,
  TEACHER = 29,
  OTHER = 23,
}

/**
 * Income types dictionary.
 * @see {@link https://github.com/finpack/universal-model/blob/master/multiform-circe/src/main/scala/pl/finpack/multiform/model/dictionaries/IncomeTypeDictionary.scala Multiform Circe Dictionary}
 * @see {@link https://github.com/finpack/universal-model/blob/master/simulation-dictionaries-circe/src/main/scala/pl/finpack/simulation/model/dictionaries/IncomeTypeDictionary.scala Simulation Dictionary}
 */
export enum IncomeType {
  CONTRACT_PERMANENT = 1,
  CONTRACT_FIXED_TERM = 2,
  CONTRACT_MANDATE_OR_SPECIFIC_WORK = 3,
  APPOINTMENT = 29,
  CONTRACT_SEA = 4,
  CONTRACT_MANAGER = 5,
  CONTRACT_MILITARY = 26,
  BUSINESS_KPIR = 6,
  BUSINESS_FLAT_TAX = 105,
  BUSINESS_CARD_TAX = 11,
  BUSINESS_FULL_ACCOUNTING = 12,
  BUSINESS_FARMER = 13,
  BUSINESS_B2B_KPIR = 106,
  BUSINESS_B2B_FLAT_TAX = 107,
  INCOME_FROM_ABROAD_PERMANENT_CONTRACT = 28,
  INCOME_FROM_ABROAD_FIXED_TERM_CONTRACT = 27,
  INCOME_FROM_ABROAD_BUSINESS = 14,
  INCOME_FROM_ABROAD_PENSION = 15,
  INCOME_FROM_ABROAD_OTHER = 16,
  RENT = 20,
  PERMANENT_PENSION = 17,
  RETIREMENT = 18,
  PRIEST = 19,
  MATERNITY_LEAVE = 21,
  DRIVERS_ALLOWANCE = 22,
  HOUSING_SUPPLEMENT = 23,
  DIVIDENDS = 24,
  /** @deprecated */
  BUSINESS_3 = 7,
  /** @deprecated */
  BUSINESS_5 = 8,
  /** @deprecated */
  BUSINESS_8 = 9,
  /** @deprecated */
  BUSINESS_17_20 = 10,
  /** @deprecated */
  CONTRACT_MANDATE = 30,
  /** @deprecated */
  STRUCTURE_PENSION = 32,
  /** @deprecated */
  PRE_PENSION = 33,
  /** @deprecated */
  TERM_PENSION = 94,
  /** @deprecated */
  WITHOUT_INCOME = 95,
  /** @deprecated */
  SOCIAL_500 = 100,
  /** @deprecated */
  BUSINESS_15 = 101,
  /** @deprecated */
  BUSINESS_12 = 102,
  /** @deprecated */
  BUSINESS_10 = 103,
  /** @deprecated */
  BUSINESS_2 = 104,
}

/**
 * Income type forms dictionary.
 * @see {@link https://github.com/finpack/fincrm/blob/master/modules/commons/app/pl/finpack/dict/IncomeTypeRepository.scala FinCRM Dictionary}
 * @see {@link https://github.com/finpack/fincrm/pull/4641/files#diff-37bc08777cfa990658654bf2b5a65073a8d25ec3f86823740e2a8b5be82a0c24 FinCRM PR Diff With Changes}
 */
export enum IncomeTypeForm {
  DEFAULT_INCOME_TYPE_FORM = 'DEFAULT_INCOME_TYPE_FORM',
  PERMANENT_INCOME_TYPE_FORM = 'PERMANENT_INCOME_TYPE_FORM',
  BUSINESS_INCOME_TYPE_FORM = 'BUSINESS_INCOME_TYPE_FORM',
  BUSINESS_WITHOUT_COSTS_INCOME_TYPE_FORM = 'BUSINESS_WITHOUT_COSTS_INCOME_TYPE_FORM',
  CARD_TAX_INCOME_TYPE_FORM = 'CARD_TAX_INCOME_TYPE_FORM',
  RENT_INCOME_TYPE_FORM = 'RENT_INCOME_TYPE_FORM',
  GENERAL_ACTIVITIES_INCOME_TYPE_FORM = 'GENERAL_ACTIVITIES_INCOME_TYPE_FORM',
}

/**
 * Income type categories dictionary.
 * @see {@link https://github.com/finpack/fincrm/blob/master/modules/commons/app/pl/finpack/dict/IncomeTypeRepository.scala FinCRM Dictionary}
 * @see {@link https://github.com/finpack/fincrm/pull/4641/files#diff-37bc08777cfa990658654bf2b5a65073a8d25ec3f86823740e2a8b5be82a0c24 FinCRM PR Diff With Changes}
 */
export enum IncomeTypeCategory {
  CONTRACT_INCOME_TYPE = 'CONTRACT_INCOME_TYPE',
  OTHER_CONTRACT_INCOME_TYPE = 'OTHER_CONTRACT_INCOME_TYPE',
  BUSINESS_INCOME_TYPE = 'BUSINESS_INCOME_TYPE',
  ABROAD_INCOME_TYPE = 'ABROAD_INCOME_TYPE',
  RETIREMENT_INCOME_TYPE = 'RETIREMENT_INCOME_TYPE',
  OTHER = 'OTHER',
}

export enum TaxType {
  THRESHOLD_TAX = 'ThresholdTax',
  LINEAR_TAX = 'LinearTax'
}

export enum EducationDegree {
  BASIC = 'basic',
  BASIC_NON_GRADUATE = 'basicNonGraduate',
  GYMNASIUM = 'gymnasium',
  WORK_PREPARE = 'workPrepare',
  MEDIUM = 'medium',
  TECHNICAL = 'technical',
  MEDIUM_AFTER = 'mediumAfter',
  HIGHER = 'higher',
  HIGHER_NON_GRADUATE = 'higherNonGraduate', // Brak obrony
  LICENSE = 'license',
  ENGINEER = 'engineer',
  MASTER = 'master',
  DOCTOR = 'doctor',
  POST_GRADUATE = 'postGraduate',
  MBA = 'mba',
}

export enum HomeStatus {
  HOUSE_OWNER_WITHOUT_MORTGAGE = 'houseOwnerWithoutMortgage',
  HOUSE_OWNER_WITH_MORTGAGE = 'houseOwnerWithMortgage',
  FLAT_OWNER_WITHOUT_MORTGAGE = 'flatOwnerWithoutMortgage',
  FLAT_OWNER_WITH_MORTGAGE = 'flatOwnerWithMortgage',
  WITH_FAMILY = 'withFamily',
  TENEMENT = 'tenement',
  CONDOMINIUM_WITHOUT_MORTGAGE = 'condominiumWithoutMortgage',
  MASTER = 'master',
  POST_GRADUATE = 'postGraduate',
  CONDOMINIUM_WITH_MORTGAGE = 'condominiumWithMortgage',
  TBS = 'tbs',
  RENTAL_FLAT = 'rentalFlat',
  RENTAL_HOUSE = 'rentalHouse',
  ACCOMODATION = 'accomodation',
  WORK_FLAT = 'workFlat',
  OTHER = 'other',
}

export enum LiabilityType {
  mortgage = 'mortgage',
  mortgageLoan = 'mortgageLoan',
  cashLoan = 'cashLoan',
  carLoan = 'carLoan',
  shopLoan = 'shopLoan',
  investLoan = 'investLoan',
  financiaLeasing = 'financiaLeasing',
  leasing = 'leasing',
  businessLoan = 'businessLoan',
  guarantee = 'guarantee',
  businessGuarantee = 'businessGuarantee',
  alimony = 'alimony',
  insurance = 'insurance',
  rent = 'rent',
  billOfExchange = 'billOfExchange',
}

export enum LimitType {
  creditCard = 'creditCard',
  businessCreditCard = 'businessCreditCard',
  accountLimit = 'accountLimit',
  businessAccountLimit = 'businessAccountLimit',
}

export enum CompanyType {
  WORK_IN_PUBLIC_OR_PRIVATE_ADMIN = 'workInPublicOrPrivateAdmin',
  WORK_IN_PERSONAL_COMPANY = 'workInPersonalCompany',
  WORK_IN_PUBLIC_COMPANY = 'workInPublicCompany',
  WORK_IN_LIMITED_COMPANY = 'workInLimitedCompany',
  WORK_IN_CIVIL_PARTNERSHIP = 'workInCivilPartnership',
  WORK_IN_GENERAL_PARTNERSHIP = 'workInGeneralPartnership',
  WORK_IN_STATE_OWNED_COMPANY = 'workInStateOwnedCompany',
  WORK_IN_ZOO = 'workInZOO',
  WORK_IN_OTHER_COMPANY_TYPE = 'workInOtherCompanyType',
  WORK_IN_BUDGET_ZONE = 'workInBudgetZone',
  WORK_IN_COOPERATIVE = 'workInCooperative',
  WORK_IN_OTHER_WORKPLACE_TYPE = 'workInOtherWorkplaceType',
}

export enum RealEstateType {
  APARTMENT = 'Apartment',
  HOUSE = 'House',
  MULTI_HOUSE = 'MultiHouse',
  OFFICE = 'Office',
  HOLIDAY_HOME = 'HolidayHome',
  BUILDING_PLOT = 'BuildingPlot',
  RECREATION_PLOT = 'RecreationPlot',
  AGRICULTURAL_PLOT = 'AgriculturalPlot',
  RECREATION_PLOT_WITH_BUILDINGS = 'RecreationPlotWithBuildings',
  RECREATION_PLOT_WITHOUT_BUILDINGS = 'RecreationPlotWithoutBuildings',
  GARAGE = 'Garage',
  CAR_PARKING = 'CarParking',
  TENEMENT_HOUSE = 'TenementHouse',
  SEGMENT = 'Segment',
  HABITATION = 'Habitation',
  STORAGE_ROOM = 'StorageRoom',
}

export enum PersonalSharesSourceType {
  BANK_ACCOUNTS = 'bankAccounts',
  BANK_DEPOSITS = 'bankDeposits',
  HOUSING_BOOKLET = 'housingBooklet',
  INVESTMENT_FUND = 'investmentFund',
  PROPERTY_SALE = 'propertySale',
  OTHER_SHARE = 'otherShare',
}

export enum AssetType {
  REALESTATE_APARTMENT = 'realestate_apartment',
  REALESTATE_PLOT = 'realestate_plot',
  REALESTATE_HOUSE_ONE_FAMILY = 'realestate_house_oneFamily',
  REALESTATE_HOUSE_MULTI_FAMILY = 'realestate_house_multiFamily',
  REALESTATE_OFFICE = 'realestate_office',
  SHARES = 'shares',
  INVESTMENT = 'investment',
  FARMER_MACHINES = 'farmer_machines',
  CAR = 'car',
}

export enum RealEstateRights {
  OWNERSHIP_RIGHT = 'ownershipRight',
  TENEMENT_RIGHT = 'tenementRight',
  CONDOMINIUM_RIGHT = 'condominiumRight',
  PERPETUAL_USUFRUCT = 'perpetualUsufruct',
  ASSET = 'asset',
  OTHER_RIGHT = 'otherRight',
}
